import { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const DEFAULTS = {
  hero_tagline: "Compro oro · Milano e Monza · dal 2009",
  hero_line1: "Da noi i tuoi",
  hero_line2_gold: "gioielli",
  hero_line2_rest: "valgono",
  hero_line3: "di più.",
  hero_sub: "Compriamo oro, argento, gioielli, orologi e diamanti con pagamento immediato, e diamo nuova vita ai tuoi preziosi.",
  buygold_title1: "Il tuo oro vale.",
  buygold_title2a: "Noi lo",
  buygold_title2_gold: "paghiamo subito",
  buygold_title2b: ".",
  buygold_sub: "Porta oro, argento, gioielli, orologi e diamanti: li valutiamo gratuitamente davanti a te e ti paghiamo all'istante, in contanti o con bonifico immediato.",
  reviews_rating: "4.7",
  reviews_count: "233",
  stores_title: "Tre negozi, una promessa",
  storia_title1: "Nel mondo dell'oro",
  storia_title2a: "da",
  storia_title2_gold: "oltre quindici anni",
  storia_title2b: ".",
  storia_sub: "La nostra realtà nasce a Monza con il nome OroOk Jewels, per poi crescere a Milano ed evolversi negli anni: oggi tutti e tre i negozi portano lo stesso nome, Oro Jewels.",
  storia_sub2: "Specializzati nel ritiro e nella vendita di oggetti preziosi, acquistiamo oro, argento, gioielli, orologi e diamanti, dando nuova vita a ciò che merita una seconda storia.",
  novita_kicker: "Dal banco",
  novita_title: "Novità",
  novita_sub: "Promozioni, nuovi arrivi e storie dal mondo Oro Jewels.",
  contatti_title: "Parliamone.",
  contatti_sub: "Una valutazione, una domanda su un gioiello, un appuntamento: scrivici come preferisci.",
  promo_title1: "Scopri la tua",
  promo_title_gold: "promo",
  promo_title2: ".",
  promo_sub: "Un giro al giorno, se vuoi un secondo tentativo, lasciaci una recensione facendoci sapere come ci hai conosciuto o come ti sei trovato con noi.",
  footer_tagline: "Da noi i tuoi gioielli valgono di più.",
};

const TextsContext = createContext(DEFAULTS);

export function TextsProvider({ children }) {
  const [texts, setTexts] = useState(DEFAULTS);

  useEffect(() => {
    client
      .get("/site-texts")
      .then((r) => setTexts((t) => ({ ...t, ...r.data })))
      .catch(() => {});
  }, []);

  return <TextsContext.Provider value={texts}>{children}</TextsContext.Provider>;
}

export function useTexts() {
  return useContext(TextsContext);
}
